import {RequireButtonProps} from "app/Interface/Component/Buttons"
import React from "react"
import {Button} from "react-bootstrap"
import {useTranslation} from "react-i18next"

function RequireButton({id, onClick, disabled, title}: RequireButtonProps) {
  const {t} = useTranslation('Components.Buttons')
  return (
    <Button
      id={`require-${id}`}
      onClick={onClick}
      disabled={disabled}
      variant={'warning'}
    >
      {t('require', {item: title})}
    </Button>
  )
}

export default RequireButton
